import React from 'react';

import { CrossIcon } from '@vlabs/icons';
import { ClearListsButton } from '@vlabs/monokit/features/clear-lists';
import { DeleteListsButton } from '@vlabs/monokit/features/delete-lists';
import type { List } from '@vlabs/api/luna-api/model';
import { TableViewHead } from '@vlabs/monokit/shared/ui/table-view';
import type { TableViewHeadProps } from '@vlabs/monokit/shared/ui/table-view/head/types';
import { BulkActions, Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './ListListTableHead.module.sass';

export function ListListTableHead({ table, ...props }: TableViewHeadProps<List>): React.JSX.Element {
  const { t } = useTranslation();

  const showBulkActionsPanel = table.getIsSomeRowsSelected() || table.getIsAllRowsSelected();
  const selectedRows = table.getSelectedRowModel().rows;
  const selectedListIds = selectedRows
    .map(({ original }) => original.list_id)
    .filter((c) => c !== undefined);

  return (
    <TableViewHead
      table={table}
      {...props}
    >
      {!!showBulkActionsPanel && (
        <BulkActions
          data-testid="ListListBulkActions"
          indeterminate={table.getIsSomeRowsSelected()}
          onCheckboxClick={table.getToggleAllRowsSelectedHandler()}
        >
          <div className={st.BulkActionsContainer}>
            <span
              className={st.SelectedListsCount}
              data-testid="ListListBulkActions-SelectedCount"
            >
              {t('list-list-page:table.bulk_actions.selected_count', { count: selectedRows.length })}
            </span>

            <div className={st.Controls}>
              <ClearListsButton
                listIds={selectedListIds}
                size="small"
                variant="flat-inverted"
              />
              <DeleteListsButton
                listIds={selectedListIds}
                size="small"
                variant="flat-inverted"
              />
              <Control.IconButton
                data-testid="ListListBulkActions-CancelBtn"
                icon={<CrossIcon />}
                kind="secondary"
                onClick={table.resetRowSelection as VoidFunction}
                shape="square"
                size="small"
                variant="flat-inverted"
              />
            </div>
          </div>
        </BulkActions>
      )}
    </TableViewHead>
  );
}
